module.exports = __webpack_public_path__ + "static/img/apidock.81b504e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/apidock.svg
// module id = Yinc
// module chunks = 1